import { IUpdateNotificationSetting } from 'modules/settings/models';
import API from 'services/api';

export const updateNotificationSettings = ({ payload }: { payload: IUpdateNotificationSetting }) =>
  API.put('/api/notifications/permits', payload);
